import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebaseConfig";
import useShopStore from "../store/useShopStore"; // import your Zustand store

export const getAllItems = async () => {
  const { shop } = useShopStore.getState(); // get current shop data
  const shopId = shop?.id;

  if (!shopId) {
    console.error("❌ No shop ID found in store — make sure shop is loaded first");
    return [];
  }

  const q = query(
    collection(db, "items"),
    where("shopId", "==", shopId),
    where("inStock", "==", true)
  );

  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};
